export default {
  differenceInDays(inittialDate: string | Date, finalDate: string | Date) {
    const inittial = new Date(inittialDate);
    const final = new Date(finalDate);
    return Math.ceil(final.getTime() - inittial.getTime()) / (1000 * 3600 * 24);
  },

  differenceInWeeks(inittialDate: string | Date, finalDate: string | Date) {
    const inittial = new Date(inittialDate);
    const final = new Date(finalDate);
    return Math.ceil(final.getTime() - inittial.getTime()) / (1000 * 3600 * 168);
  },

  differenceInMonths(inittialDate: string | Date, finalDate: string | Date) {
    const inittial = new Date(inittialDate);
    const final = new Date(finalDate);
    return Math.ceil(final.getTime() - inittial.getTime()) / (1000 * 3600 * (180 * 4));
  },
};
